export const apiPrefix = '/orbit2-web/api'

export const ApiAddress = {
  SIGN_UP: '/passport/sign-up',
  SIGN_IN: '/passport/sign-in',
  USER: '/user',
  USER_ID: '/user/:id',
  USERS: '/users',
  USERS_ORGS: '/users-orgs',
  USERS_PASSWORD: '/users/password',
  PROJECTS: '/projects',
  LIBRARIES: '/libraries',
  PROJECT: '/projects/:id',
  LIBRARY: '/libraries/:id',
  ODMDATA: '/:type/:id/odm-data',
  PROJECT_TYPE_ITEMS: '/projects',
  PROJECT_TYPE_ITEM: '/projects/:projectId',
  ORGANIZATIONS: '/organizations',
  ORGANIZATION: '/organizations/:id',
  ORGANIZATION_LEAVE: '/organizations/:id/leave',
  USER_ORG_ACCOUNT: '/organizations/:id/members/current',
  ORGANIZATION_ACCOUNT: '/organizations/:id/account',
  ORGANIZATION_PROJECTS: '/organizations/:id/projects',
  ORGANIZATION_PROJECT: '/organizations/:orgId/projects/:id',
  ORGANIZATION_LIBRARIES: '/organizations/:id/libraries',
  ORGANIZATION_LIBRARIE: '/organizations/:orgId/libraries/:id',
  ORGANIZATION_ROOT_LIBRARY_LIBRARIES: '/organizations/:id/root-libraries/:rId/libraries',
  ORGANIZATION_ROOT_PROJECTS: '/organizations/:id/root-projects',
  ORGANIZATION_ROOT_PROJECT: '/organizations/:orgId/root-projects/:id',
  ORGANIZATION_ROOT_LIBRARIES: '/organizations/:id/root-libraries',
  ORGANIZATION_ROOT_LIBRARIE: '/organizations/:orgId/root-libraries/:id',
  ORGANIZATION_MEMBERS: '/organizations/:id/members',
  ORGANIZATION_MEMBER_OUTSIDE_MEMBER_GROUP: '/organizations/:id/members/:mId/outside-member-group',
  ORGANIZATION_MEMBER_MEMBER_GROUP: '/organizations/:id/members/:mId/member-group',
  USER_PROJECT_ACCOUNT: '/projects/:id/members/current',
  PROJECT_ROLES: '/projects/:projectId/roles',
  PROJECT_ROLE: '/projects/:projectId/roles/:id',
  USER_PROJECT_ROLE: '/projects/:projectId/role',
  DEPENDENCIES_AUTOCOMPLETE: '/dependencies-autocomplete',
  PROJECT_MEMBERS: '/projects/:projectId/members',
  PROJECT_MEMBER_LEAVE: '/projects/:projectId/leave',
  PROJECT_MEMBER: '/projects/:projectId/members/:mId',
  INVITATIONS_PENDING: '/projects/:projectId/invitations/pending',
  INVITATIONS_FAILED: '/projects/:projectId/invitations/failed',
  PROJECT_TASKS: '/projects/:projectId/tasks',
  PROJECT_CLOSED_TASKS: '/projects/:projectId/closed-tasks',

  TASK: '/tasks/:id',
  TASK_ORDER: '/tasks/:id/order',
  TASK_DATE: '/tasks/:id/date',
  SUB_TASKS: '/tasks/:id/sub-tasks',
  PRE_TASKS: '/tasks/:id/predecessor-tasks',
  LINK_PRE_TASKS: '/tasks/:id/link-predecessor-tasks',
  UNLINK_PRE_TASKS: '/tasks/:id/unlink-predecessor-tasks',
  TASK_COMMENTS: '/tasks/:id/comments',
  COMMENT: '/comments/:id',

  PROJECT_DIRECTORIES: '/projects/:projectId/directories',
  PROJECT_FILES_TREE: '/projects/:projectId/files-tree',
  PROJECT_DIRECTORY_FILE: '/projects/:projectId/directory-files/:id',
  DIRECTORY_FILES: '/directory/:id/files',
  DIRECTORY_FILE: '/directory-files/:id',

  ORGANIZATION_MEMBER: '/organizations/:id/members/:mId',
  ORGANIZATION_MEMBER_RESET_PASSWORD: '/organizations/:id/members/:mId/reset-password',
  ORGANIZATION_MEMBER_GROUPS: '/organizations/:id/member-groups',
  ORGANIZATION_MEMBER_GROUP: '/organizations/:id/member-groups/:gId',
  ORGANIZATION_GROUP_MEMBERS: '/organizations/:id/member-groups/:gId/members',
  ORGANIZATION_TERMS_LIBRARY_TERMS: '/organizations/:id/terms-library/:tId/terms',
  ORGANIZATION_TERMS: '/organizations/:id/terms',
  TERM: '/terms/:id',
  INVITATIONS: '/invitations',
  INVITATION_TOKEN: '/invitation/:token',
  INVITATION: '/invitation/:id',
  INVITATION_REJECT: '/invitation/:token/reject',
  NOTIFICATIONS: '/notifications',
  NOTIFICATIONS_COUNT: '/notifications/count',
  NOTIFICATIONS_READED: '/notifications/read',
  NOTIFICATIONS_REMOVES: '/notifications/remove',
  STATIC_FILES: '/static/files',
  AVATARS: '/avatars',
  ODM_FILES: '/odm/files',
  ODM_FILE: '/odm/files/:md5',
  QUERY_ODM_DETAIL: '/odm-objects/query-rels',
  QUERY_ODM_PURE: '/odm-objects/query-node',
  RD_ACCESS: '/odm-data/rd-access',
  OBJ_VERSIONS: '/odm-data/:type/:id/versions',

  PUSH_CHAT: '/push/chat',
  CHAT_ROOMS: '/chat/rooms',
  CHAT_ROOM: '/chat/rooms/:id',
  CHAT_ROOM_READ: '/chat/rooms/:id/read',
  CHAT_ROOM_MEMBERS: '/chat/rooms/:id/members',
  CHAT_ROOM_MEMBER: '/chat/rooms/:id/members/:memberId',
  CHAT_ROOM_MESSAGES: '/chat/rooms/:id/messages',
  CHAT_ROOM_MESSAGE: '/chat/rooms/:id/messages/:messageId',

  UNIT_SETS: '/projects/:projectId/unit-sets',
  UNIT_SET: '/projects/:projectId/unit-sets/:id',
  UNIT_SET_ACTIVE: '/projects/:projectId/unit-sets/:id/active',
  UNIT_SET_UNITS: '/projects/:projectId/unit-sets/:id/units',
  UNIT_SET_UNIT: '/projects/:projectId/unit-sets/:id/units/:uid',
  ACTIVED_UNIT_SET: '/projects/:projectId/unit-sets/active',

  // equipments
  EQUIPMENTS: '/equipment',
  EQUIPMENT: '/equipment/:id',
  EQUIPMENT_NOZZLES: '/equipment/:equipmentId/nozzles',
  EQUIPMENT_NOZZLE: '/equipment/:equipmentId/nozzles/:id',
  GET_NOZZLE_SHAPES: '/nozzleshapes',
  NOZZLE_SHAPES: '/nozzleshapes',
  NOZZLE_SHAPE: '/nozzleshapes/:id',
  FLOW_MENUS: '/flow/equipment-palette-containers',
  EQUIPMENT_MENUS: '/equipment-palette-containers',
  EQUIPMENT_MENU: '/equipment-palette-containers/:id',
  ORGANIZATION_EQUIPMENTS: '/organizations/:orgId/equipment',
  ORGANIZATION_EQUIPMENT_MENUS: '/organizations/:orgId/equipment-palette-containers',
  //Admin
  DIMENSIONS: '/dimensions',
  DIMENSION: '/dimensions/:id',
  DIMENSION_UNITS: '/dimensions/:id/units',
  DIMENSION_UNIT: '/dimensions/:id/units/:uid',
  // Components
  ALL_COMPONENTS: '/components/p/:pId/all',
  COMPONENTS: '/components/p/:pId',
  COMPONENT: '/components/p/:pId/:id',
  ADMIN_COMPONENTS: '/components',
  ADMIN_COMPONENT: '/components/:id',
  DELETE_COMPONENT: '/components/:id',
  ORGANIZATION_COMPONENTS: '/organizations/:orgId/components',
  ORGANIZATION_COMPONENT: '/components/:id',
  // property-sets
  PROPERTY_SETS: '/property-sets',
  PROPERTY_SET: '/property-sets/:id',
  PROPERTY_SET_REACTIONS: '/property-sets/:setId/reactions',
  PROPERTY_SET_REACTION: '/property-sets/:setId/reactions/:id',
  REACTION_SETS: '/property-sets/:setId/reaction-sets',
  REACTION_SET: '/property-sets/:setId/reaction-sets/:id',
  PROPERTY_SET_JSON: '/property-sets/:setId/initalize-json-to-default',
  UPDATE_SET_JSON: '/property-sets/:setId/simulation-json',

  ORGANIZATION_PROPERTY_SETS: '/organizations/:orgId/property-sets',
  ORGANIZATION_PROPERTY_SET: '/property-sets/:id',
  ORGANIZATION_PROPERTY_SET_REACTIONS: '/property-sets/:setId/reactions',
  ORGANIZATION_PROPERTY_SET_REACTION: '/property-sets/:setId/reactions/:id',
  ORGANIZATION_REACTION_SETS: '/property-sets/:setId/reaction-sets',
  ORGANIZATION_REACTION_SET: '/property-sets/:setId/reaction-sets/:id',
  ORGANIZATION_PROPERTY_SET_JSON: '/property-sets/:setId/initalize-json-to-default',
  ORGANIZATION_UPDATE_SET_JSON: '/property-sets/:setId/simulation-json',

  // flowsheets
  FLOWSHEETS: '/projects/:pId/flowsheets',
  FLOWSHEET: '/flowsheets/:id',
  FS_TEMPLATES: '/projects/:pId/fs-templates',
  FS_TEMPLATE: '/fs-templates/:id',

  // Cases
  CASES: '/projects/:pId/cases',
  CASE: '/cases/:id',
  // Simulation
  FS_SIMULATIONS: '/sim/fs/:fsId/cases',
  ALL_PROPERTY_SETS: '/property-sets',
  PROJECT_PROPERTY_SETS: '/projects/:pId/tpps',
  PROJECT_PROPERTY_SET: '/projects/:pId/tpps/:id',
  INIT_SIMULATION: '/sim/open/:fsId/:caseId',
  SIM_PROPERTY_SETS: '/sim/:sId/tpps',
  SIM_TOPOLOGY: '/sim/:sId/topology',
  SIM_MANUAL_INPUTS: '/sim/:sId/desvars',
  SIM_SEQS: '/sim/:sId/seqs',
  SIM_SEQ: '/sim/:sId/seqs/:id',
  SIM_SEQ_RUN: '/sim/:sId/seqs/:id/run',
  SIM_SEQ_RERUN: '/sim/:sId/seqs/:id/rerun',
  SIM_UNIT_DATA: '/sim/:sId/unit/:id',
  UPDATE_UNIT_TTPS: '/sim/:sId/propagate-ttps',
  SAVE_SIM: '/sim/:sId/save',
  ADD_MANUAL_INPUT: '/sim/:sId/desvars/add',
  REMOVE_MANUAL_INPUT: '/sim/:sId/desvars/remove',
  SAVE_MANUAL_INPUT: '/sim/:sId/desvars',
  LOAD_SIM: '/sim/:sId/load',
  UNLOAD_SIM: '/sim/:sId/unload',
  CONDITION_ACTION: '/sim/:sId/conditions/add',
  CONDITION_ACTION_REMOVE: '/sim/:sId/conditions/remove',
  UPDATE_TOPOLOPY: '/sim/:sId/updatetopology',
  CHECK_TOPOLOPY: '/sim/:sId/checktopology',
  SET_OPS: '/sim/:sId/setops',
  SIM_RXSET: '/sim/:sId/rxset',
  UNIT_BALANCE_POINT: '/sim/:sId/units/:id/balance-point',
  SIM_PPS_TRANSITIONS: '/sim/:sId/PPSTransitions',
  SIM_PPS_TRANSITION: '/sim/:sId/PPSTransitions/:id',
  // Stream
  STREAMS: '/p/:pId/simulation-streams',
  STREAM: '/p/:pId/simulation-streams/:id',
  SINGLE_STREAM: '/simulation-streams/:id',
  // Balance
  GENERATE_STREAMS: '/sim/:sId/gendata',
  MATERIAL_STREAM_LIST: '/streams/p/:pId/index',
  MATERIAL_BLANCE_LIST: '/streams/p/:pId/mb/index',
  MATERIAL_BLANCES: '/streams/p/:pId/mb',
  MATERIAL_BLANCE: '/streams/mb/:id',
  GET_MATERIAL_BLANCE: '/streams/mb/:id/cfg',
  MATERIAL_BLANCE_CASE: '/streams/mb/:id/case/:caseId',
  // Site
  CONTACT_INFO_LIST: '/contact-info',
  CONTACT_INFO_ITEM: '/contact-info/:id',
  // payment
  CHECKOUT_SESSION: '/subscription/stripe/checkout',
  PLANS: '/plans',
  PAYMENT_STATUS: '/payments/:id/status',
  // Subscriptions
  SUBSCRIPTIONS: '/subscription',
  SUBSCRIPTION_ITEM: '/subscription/:id',
  USER_SUBSCRIPTION_ITEM: '/subscription/user/:id',
  CURRENT_PLAN: '/current-plan',
  CANCEL_MY_SUBSCRIPTION: '/subscription/me/cancel',
  REGISTER_VERIFY_RESEND: '/passport/verify-email',
  FORGOT_PASSWORD: '/passport/forgot-password',
  RESET_PASSWORD: '/passport/reset-password/:token',
  VERIFY_USER_EMAIL: '/passport/user/verify/:token',
  PLAN_PERMISSIONS: '/plans/permissions',
  PLAN_PERMISSION: '/plans/permissions/:code',
  PERMISSIONS_IN_PLAN: '/plans/:id/permissions'
}

Object.keys(ApiAddress).forEach((key) => {
  // @ts-ignore
  ApiAddress[key] = apiPrefix + ApiAddress[key]
})
